import { makeAutoObservable } from 'mobx';

class ViewStore {
  // @ts-ignore
  view = window.CRO_899 === 2 ? 'map' : 'list';
  locationName = '';

  constructor() {
    makeAutoObservable(this);
  }

  setView = (view: string) => {
    this.view = view;
  };
  setLocationName(name: string) {
    this.locationName = name;
  };
}

export const viewStore = new ViewStore();
